import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideDeleteModal } from "store/slices/modalSlice";
import DeleteIcon from "assets/icons/delete.svg";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { handleDeleteItem } from "helpers/apiUtils";
import {
  deleteAddon,
  deletePlan,
  updateAddonStatus,
} from "store/slices/membershipSlice";
import { deleteUser } from "store/slices/usersSlice";
import { deleteRole } from "store/slices/rolesSlice";
import { deleteVehicleMake } from "store/slices/vehicleMakeSlice";
import { deleteVehicleModel } from "store/slices/vehicleModelSlice";
import { deleteVehicleColor } from "store/slices/vehicleColorSlice";
import { deleteBranch } from "store/slices/branchesSlice";
import { deleteBanner } from "store/slices/bannersSlice";
import { deleteNotification } from "store/slices/notificationSlice";
import { deleteNotificationRule } from "store/slices/notificationRulesSlice";
import { deleteCoupon } from "store/slices/couponSlice";
import { deleteStoreCamera } from "store/slices/storeCameraSlice";
import { deleteDynamicPrice } from "store/slices/dynamicPricesSlice";

const GlobalDeleteModal = () => {
  const dispatch = useDispatch();
  const { deleteModal } = useSelector((state) => state.modal);
  const { show, title, message, isLoading, itemId, actionType } =
    deleteModal || {};
  const { t } = useTranslation();

  const handleDelete = () => {
    switch (actionType) {
      case "USER": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteUser,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "ROLE": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteRole,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "ADDON": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteAddon,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "PLAN": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deletePlan,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "BRANCH": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteBranch,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "BANNER": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteBanner,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "VEHICLE_MAKE": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteVehicleMake,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "VEHICLE_MODEL": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteVehicleModel,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "VEHICLE_COLOR": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteVehicleColor,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "NOTIFICATION": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteNotification,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "NOTIFICATION_RULE": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteNotificationRule,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "COUPON": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteCoupon,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "STORE_CAMERA": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: () => deleteStoreCamera(itemId),
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      case "DYNAMIC_PRICES": {
        handleDeleteItem({
          id: itemId,
          dispatch,
          action: deleteDynamicPrice,
          onSuccess: () => dispatch(hideDeleteModal()),
        });
        break;
      }
      default :{}
      break;
    }
  };

  return (
    <Modal
      show={show}
      centered
      onHide={() => dispatch(hideDeleteModal())}
      className="delete_modal"
    >
      <div className="inner_section">
        <img
          src={DeleteIcon}
          className="delete_icon"
          alt="delete icon"
          width={48}
          height={48}
        />
        <div>
          <h2>{title}</h2>
          <p>{message}</p>
        </div>
      </div>

      <div className="buttons">
        <button
          className="delete_btn outline"
          onClick={() => dispatch(hideDeleteModal())}
        >
          {t("Cancel")}
        </button>
        <button
          className="delete_btn"
          onClick={handleDelete}
          disabled={isLoading}
        >
          {t("Delete")}
        </button>
      </div>
    </Modal>
  );
};

export default GlobalDeleteModal;
